"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHomeZhTranslate = void 0;
exports.defaultHomeZhTranslate = {
    featureTitle: '香港值得信賴的地產代理',
    forSale: '物業出售',
    forRent: '物業出租',
    keyword: '搜尋',
    keywordHint: '大廈名稱',
    district: '地區',
    search: '搜尋',
    popularLabel: '熱門分區',
    latest: '最新放盤',
    featured: '精選豪宅',
    listprop: '業主放盤',
    career: '加入我們',
    hotSale: '熱門售盤',
    hotRent: '熱門租盤',
    testimonialTitle: '客戶對我們的嘉許',
    calcHead: '按揭計算機',
    calcCaption: '搜尋 {} 的樓盤',
    calcPrice: '物業價格',
    calcMortgage: '貸款比率%',
    calcRate: '貸款利率%',
    calcDuration: '貸款年期 (年)',
    calcOwnProp: '我現時擁有香港物業',
    calcNonHk: '我是香港居民及非企業買家',
    calcHasTransaction: '內有成交記錄',
    calcResultOverview: '按揭計劃',
    calcResultPlan: '還款計劃',
    calcResultRateTable: '利率與供款',
    calcResultTotal: '總供款',
    calcResultMonthly: '每月供款',
    calcResultMortgageAmount: '按揭金額',
    calcResultMortgageInterestExpenses: '總利息開支',
    calcResultTotalCashOutlay: '總現金支出',
    calcResultTotalCashDownPayment: '首期（訂金）',
    calcResultTotalCashInsurance: '按揭保險',
    calcResultTotalCashStampDuty: '印花稅資格**',
    calcResultTotalCashCommission: '代理佣金***',
    calcResultDisclaimer1: '** 印花稅由政府擬定',
    calcResultDisclaimer2: '*** 實際代理佣金待地產顧問確認',
    analysis: '專家分析',
    tips: '買家錦囊',
    newsTitle: '地產新聞及評論',
    hki: '香港島',
    kln: '九龍',
    ntr: '新界',
    oli: '離島',
    suggestion: '建議',
    more: '更多',
    years: '年',
    noMonth: '期數(月)',
    payment: '還款',
    principle: '本金',
    interest: '利息',
    balance: '餘額',
    fgp: '福布斯全球物業',
    noMorgagePlanAvailable: '無可行的按揭計劃',
};
